<img [src]="logoPath" alt="PwC Logo" />
